// src/components/structure/StructureBody.js
import DraggableRow from './DraggableRow';

/**
 * ストラクチャーテーブルのボディ全体をレンダリングするコンポーネント
 */
const StructureBody = ({
  rows,
  columns,
  events,
  timerState,
  rowIndex: timerRowIndex,
  canEditSpecificRowContent,
  canDeleteRow,
  canInsertRow,
  canDragRow,
  onInsertRow,
  onDeleteRow,
  onInsertBreakRow,
  onChangeRow,
  onEditEvent,
}) => {
  return (
    <tbody>
      {rows.map((row, idx) => (
        <DraggableRow
          key={row.id}
          id={row.id}
          row={row}
          columns={columns}
          tableRowIndex={idx}
          events={events.filter(e => e.rowIndex === idx)}
          timerState={timerState}
          timerRowIndex={timerRowIndex}
          canEditThisRowContent={canEditSpecificRowContent(idx)}
          canDeleteThisRow={canDeleteRow(idx)}
          canInsertThisRow={canInsertRow(idx)}
          canDragRow={canDragRow}
          onInsertRow={onInsertRow}
          onDeleteRow={onDeleteRow}
          onInsertBreakRow={onInsertBreakRow}
          onChangeRow={onChangeRow}
          onEditEvent={onEditEvent}
        />
      ))}
    </tbody>
  );
};

export default StructureBody;